import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "./MenuForm.css";

const MenuForm = ({ buttonText, handleFormSubmit }) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [img, setImg] = useState("");
  const [rating, setRating] = useState("");
  const [category, setCategory] = useState("");
  const [loading, setLoading] = useState(true);

  const { id } = useParams();

  useEffect(() => {
    console.log(id)
    if (id) {
      axios.get(`/service/${id}`).then((response) => {
        setTitle(response.data.title);
        setDescription(response.data.description);
        setImg(response.data.img);
        setRating(response.data.rating);
        setCategory(response.data.category);
        setLoading(false);
      }).catch((err)=>{
        setLoading(false);
      })
    } else {
      setLoading(false);
    }
  }, [id]);

  if(loading) return null;

  return (
    <form
      className="col s12"
      onSubmit={(e) => {
        handleFormSubmit(e, { title, description, img, rating, category }, id);
      }}
    >
      <div className="row">
        <div className="input-field col s6">
          <input
            placeholder="Service Title"
            id="title"
            type="text"
            className="validate foodFormInput"
            name="title"
            value={title}
            onChange={(e) => {
              setTitle(e.target.value);
            }}
          />
        </div>

        <div className="input-field col s6">
          <input
            placeholder="Image Url"
            id="img"
            type="text"
            className="validate foodFormInput"
            name="img"
            value={img}
            onChange={(e) => {
              setImg(e.target.value);
            }}
          />
        </div>
        <div className="input-field col s6">
          <input
            placeholder="Price"
            id="rating"
            type="text"
            className="validate foodFormInput"
            name="rating"
            value={rating}
            onChange={(e) => {
              setRating(e.target.value);
            }}
          />
        </div>
        <div className="input-field col s6">
          <input
            placeholder="Category (singular)"
            id="category"
            type="text"
            className="validate foodFormInput"
            name="category"
            value={category}
            onChange={(e) => {
              setCategory(e.target.value);
            }}
          />
        </div>
        <div className="input-field col s12">
          <input
            placeholder="Description"
            id="description"
            type="text"
            className="validate foodFormInput"
            name="description"
            value={description}
            onChange={(e) => {
              setDescription(e.target.value);
            }}
          />
        </div>
        <div className="col s12">
          <button
            className="btn waves-effect waves-light submit-button"
            type="submit"
            name="action"
          >
            {buttonText}
          </button>
        </div>
      </div>
    </form>
  );
};

export default MenuForm;
